<div class="grid gap-[16px]">
  <app-feature-list-container
    title="{{
      '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.SYSTEM_OPERATOR_SETTINGS' | translate
    }}"
  >
    <div class="feature-grid-container" viFeatureGrid viBorderBottom>
      <!-- heating.secondaryHeatGenerator.operating.modes.active -->
      <vi-item
        data-at-secondary-heat-generator-operating-modes-active
        *ngIf="controlStrategy$ | async | ready as feature"
        [title]="'+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.CONTROL_STRATEGY.TITLE' | translate"
        [asDropdown]="feature | executable: featureCommands.setMode"
        [value]="feature.properties.value.value"
        [options]="controlStrategyEnum"
        (valueChange)="onControlStrategyChange($event)"
      ></vi-item>

      <!-- value2 pipe is not used due to number rounding -->

      <!-- heating.secondaryHeatGenerator.fossil.price.normal -->
      <app-feature-list-item
        data-at-secondary-heat-generator-fossil-price-normal
        *ngIf="heatGeneratorEnergyCosts$ | async | ready as feature"
        [label]="
          '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.EXTERNAL_HEAT_GENERATOR_COSTS.TITLE'
            | translate
        "
        value="{{ feature.properties.value.value }} {{ currencyOfConsumption }}"
        [attr.data-feature]="feature.feature"
        [editable]="feature | executable: featureCommands.setTariff"
        (edit)="onEdit(feature, featureCommands.setTariff, featurePropertyKey.price, true)"
      ></app-feature-list-item>

      <!-- heating.secondaryHeatGenerator.electricity.energyFactor -->
      <app-feature-list-item
        data-at-secondary-heat-generator-electricity-energy-factor
        *ngIf="primaryEnergyFactorExternalElectricityEnergyFactor$ | async | ready as feature"
        [label]="
          '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.PRIMARY_ENERGY_FACTOR_HEAT_PUMP.TITLE'
            | translate
        "
        value="{{ feature | value2: featurePropertyKey.value }}"
        [attr.data-feature]="feature.feature"
        [editable]="feature | executable: featureCommands.setEnergyFactor"
        (edit)="onEdit(feature, featureCommands.setEnergyFactor, featurePropertyKey.factor)"
      ></app-feature-list-item>

      <!-- heating.secondaryHeatGenerator.electricity.price.normal -->
      <app-feature-list-item
        data-at-secondary-heat-generator-electricity-price-normal
        *ngIf="electricityNormalRate$ | async | ready as feature"
        [label]="
          '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.ELECTRICITY_NORMAL_RATE.TITLE' | translate
        "
        value="{{ feature.properties.value.value }} {{ currencyOfConsumption }}"
        [editable]="feature | executable: featureCommands.setTariff"
        (edit)="onEdit(feature, featureCommands.setTariff, featurePropertyKey.price, true)"
      >
      </app-feature-list-item>

      <!-- heating.secondaryHeatGenerator.fossil.energyFactor -->
      <app-feature-list-item
        data-at-secondary-heat-generator-external-heat-generator
        *ngIf="primaryEnergyFactorExternalHeatGenerator$ | async | ready as feature"
        [label]="
          '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.PRIMARY_ENERGY_EXTERNAL_FACTOR_HEAT_GENERATOR.TITLE'
            | translate
        "
        value="{{ feature | value2: featurePropertyKey.value }}"
        [attr.data-feature]="feature.feature"
        [editable]="feature | executable: featureCommands.setEnergyFactor"
        (edit)="onEdit(feature, featureCommands.setEnergyFactor, featurePropertyKey.factor)"
      ></app-feature-list-item>

      <!-- heating.secondaryHeatGenerator.electricity.price.low -->
      <app-feature-list-item
        data-at-secondary-heat-generator-electricity-price-low
        *ngIf="electricityLowRate$ | async | ready as feature"
        [label]="
          '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.ELECTRICITY_LOW_RATE.TITLE' | translate
        "
        value="{{ feature.properties.value.value }} {{ currencyOfConsumption }}"
        [attr.data-feature]="feature.feature"
        [editable]="feature | executable: featureCommands.setTariff"
        (edit)="onEdit(feature, featureCommands.setTariff, featurePropertyKey.price, true)"
      ></app-feature-list-item>
    </div>
  </app-feature-list-container>

  <!-- heating.secondaryHeatGenerator.electricity.price.schedule -->
  <ng-container
    *ngIf="electricityPriceTimeSchedule$ | async | ready as electricityPriceTimeSchedule"
  >
    <div class="section-wrapper">
      <h3>
        {{
          '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.ELECTRICITY_PRICE_TIME_SCHEDULE.TITLE'
            | translate
        }}
      </h3>
      <app-timemanager
        class="gap"
        (scheduleChange)="onScheduleChange($event, electricityPriceTimeSchedule)"
      >
      </app-timemanager>
      <div class="programs-container flex flex-row justify-between items-center">
        <button
          mat-stroked-button
          color="primary"
          gtm="onOpen"
          gtmAction="Multiple days selection dialog"
          gtmCategory="electricity price time schedule"
          id="edit-multiple-ept-btn"
          data-at-edit-multiple
          (click)="onEditMultipleDays()"
        >
          {{ '+SCHEDULES.BUTTON.EDIT_MULTIPLE_DAYS' | translate }}
        </button>
        <div data-at-programs class="programs flex flex-row gap-[30px] justify-end">
          <vi-program-item
            *ngFor="let program of programs$ | async"
            program="{{ program.css }} {{ 'etp' }}"
            [hasTemperature]="false"
          >
            <vi-text name fxFlex class="capitalize">
              {{ program?.name | translateOperatingProgram }}
            </vi-text>
          </vi-program-item>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container
    *ngrxLet="{
      isProOrPlus: installationDetailsStore.isPlusOrProPackage$ | async,
      isRSAUser: authStore.isRsaUser() | async
    } as visibilityConditions"
  >
    <app-feature-list-container
      [title]="'+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.INSTALLER_SETTINGS.TITLE' | translate"
      [tooltipText]="
        (visibilityConditions.isProOrPlus || visibilityConditions.isRSAUser
          ? ''
          : '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.INSTALLER_SETTINGS.TOOLTIP'
        ) | translate
      "
    >
      <div
        *ngIf="visibilityConditions.isProOrPlus || visibilityConditions.isRSAUser; else noAccess"
      >
        <div class="feature-grid-container" viFeatureGrid viBorderBottom>
          <!-- heating.configuration.secondaryHeatGenerator -->
          <vi-item
            data-at-secondary-heat-generator-configuration
            class="control-mode-select"
            *ngIf="controlMode$ | async | ready as feature"
            [title]="'+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.CONTROL_MODE.TITLE' | translate"
            [value]="feature | value2: featurePropertyKey.value"
            [options]="controlModeEnum"
            [asDropdown]="feature | executable: featureCommands.setMode"
            [attr.feature]="feature.feature"
            (valueChange)="onControlModeChange($event)"
          ></vi-item>

          <!-- heating.secondaryHeatGenerator.temperature.bivalencePoint -->
          <app-temperature-select
            *ngIf="secondaryHeatGeneratorBivalencePoint$ | async | ready as feature"
            [attr.data-feature]="feature.feature"
            [isTile]="true"
            id="min-temperature-select-operating-modes-fixed-min-temperature"
            [title]="'+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.DUAL_MODE.TITLE' | translate"
            [rangeDefinition]="feature | constraints: 'setTemperature':'temperature'"
            [value]="feature?.properties?.value?.value"
            (valueChange)="onDualModeChange($event)"
          >
          </app-temperature-select>

          <!-- heating.secondaryHeatGenerator.temperature.alternativePoint -->
          <app-temperature-select
            *ngIf="secondaryHeatGeneratorAlternativePoint$ | async | ready as feature"
            [attr.data-feature]="feature.feature"
            [isTile]="true"
            id="min-temperature-select-operating-modes-fixed-max-temperature"
            [title]="
              '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.ALTERNATIVE_POINT.TITLE' | translate
            "
            [rangeDefinition]="feature | constraints: 'setTemperature':'temperature'"
            [value]="feature?.properties?.value?.value"
            (valueChange)="onAlternativePointChange($event)"
          >
          </app-temperature-select>
        </div>
        <div class="feature-grid-container" viFeatureGrid>
          <!-- heating.secondaryHeatGenerator.configuration.runtime/delay -->
          <app-feature-list-item
            data-at-secondary-heat-generator-configuration-runtime-delay
            *ngIf="secondaryHeatGeneratorConfigurationRuntime$ | async | ready as feature"
            [label]="'+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.START_DELAY.TITLE' | translate"
            [value]="feature?.properties?.delay?.value | minutesOrHours"
            [attr.feature]="feature.feature"
            [editable]="feature | executable: featureCommands.setDelayTime"
            (edit)="
              onEditRuntime(
                feature,
                featureCommands.setDelayTime,
                featurePropertyKey.delay,
                featureActionFields.delayTime
              )
            "
          >
          </app-feature-list-item>

          <!-- heating.secondaryHeatGenerator.configuration.runtime/break -->
          <app-feature-list-item
            data-at-secondary-heat-generator-configuration-runtime-break
            *ngIf="secondaryHeatGeneratorConfigurationRuntime$ | async | ready as feature"
            [label]="
              '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.SHUT_DOWN_DELAY.TITLE' | translate
            "
            [value]="feature?.properties?.break?.value | minutesOrHours"
            [attr.feature]="feature.feature"
            [editable]="feature | executable: featureCommands.setBreakTime"
            (edit)="
              onEditRuntime(
                feature,
                featureCommands.setBreakTime,
                featurePropertyKey.break,
                featureActionFields.breakTime
              )
            "
          >
          </app-feature-list-item>

          <!-- heating.secondaryHeatGenerator.configuration.runtime/minimal -->
          <app-feature-list-item
            data-at-secondary-heat-generator-configuration-runtime-minimal
            *ngIf="secondaryHeatGeneratorConfigurationRuntime$ | async | ready as feature"
            [label]="
              '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.MINIMAL_RUNTIME.TITLE' | translate
            "
            [value]="feature?.properties?.minimal?.value | minutesOrHours"
            [attr.feature]="feature.feature"
            [editable]="feature | executable: featureCommands.setMinimalRuntime"
            (edit)="
              onEditRuntime(
                feature,
                featureCommands.setMinimalRuntime,
                featurePropertyKey.minimal,
                featureActionFields.minimalRuntime
              )
            "
          >
          </app-feature-list-item>
        </div>
        <div class="feature-grid-container" viFeatureGrid viBorderBottom>
          <!-- heating.secondaryHeatGenerator.configuration.timeIntegralThreshold -->
          <app-feature-list-item
            data-at-secondary-heat-generator-configuration-time-integral-threshold
            *ngIf="
              secondaryHeatGeneratorConfigurationTimeIntegralThreshold$ | async | ready as feature
            "
            [label]="
              '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.INTEGRAL_THRESHOLD.TITLE' | translate
            "
            value="{{ feature | value2: featurePropertyKey.value }} {{
              feature | unit: featurePropertyKey.value
            }}"
            [editable]="feature | executable: featureCommands.setValue"
            (edit)="
              onEdit(
                feature,
                featureCommands.setValue,
                featurePropertyKey.value,
                false,
                featureActionFields.turnOn
              )
            "
            [attr.feature]="feature.feature"
          >
          </app-feature-list-item>

          <!-- heating.secondaryHeatGenerator.temperature.offset -->
          <app-feature-list-item
            data-at-secondary-heat-generator-temperature-offset
            *ngIf="secondaryHeatGeneratorTemperatureOffset$ | async | ready as feature"
            [label]="
              '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.TEMPERATURE_OFFSET.TITLE' | translate
            "
            value="{{ feature | value2: featurePropertyKey.value }} {{
              feature | unit: featurePropertyKey.value
            }}"
            [editable]="feature | executable: featureCommands.setValue"
            (edit)="onEditOffsetValues(feature, featureCommands.setValue, featurePropertyKey.value)"
            [attr.feature]="feature.feature"
          >
          </app-feature-list-item>

          <!-- heating.secondaryHeatGenerator.dhw.offset -->
          <app-feature-list-item
            data-at-secondary-heat-generator-dhw-offset
            *ngIf="secondaryHeatGeneratorDhwOffset$ | async | ready as feature"
            [label]="'+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.OFFSET_DHW.TITLE' | translate"
            value="{{ feature | value2: featurePropertyKey.value }} {{
              feature | unit: featurePropertyKey.value
            }}"
            [editable]="feature | executable: featureCommands.setValue"
            (edit)="onEditOffsetValues(feature, featureCommands.setValue, featurePropertyKey.value)"
            [attr.feature]="feature.feature"
          >
          </app-feature-list-item>
        </div>
      </div>
      <ng-template #noAccess>
        <div class="feature-grid-container" viFeatureGrid>
          <!-- heating.configuration.secondaryHeatGenerator -->
          <app-feature-list-item
            data-at-secondary-heat-generator-configuration
            *ngIf="controlMode$ | async | ready as feature"
            [label]="'+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.CONTROL_MODE.TITLE' | translate"
            [value]="feature | value2: featurePropertyKey.value | hybridProGeneratorModes"
            [attr.feature]="feature.feature"
          >
          </app-feature-list-item>
          <!-- heating.secondaryHeatGenerator.temperature.bivalencePoint -->
          <app-feature-list-item
            data-at-heating-secondaryHeatGenerator-temperature-bivalencePoint
            *ngIf="secondaryHeatGeneratorBivalencePoint$ | async | ready as feature"
            [label]="'+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.DUAL_MODE.TITLE' | translate"
            value="{{ feature | value2: featurePropertyKey.value }} {{
              feature | unit: featurePropertyKey.value
            }}"
            [attr.feature]="feature.feature"
          >
          </app-feature-list-item>

          <!-- heating.secondaryHeatGenerator.temperature.alternativePoint -->
          <app-feature-list-item
            data-at-heating-secondaryHeatGenerator-temperature-alternativePoint
            *ngIf="secondaryHeatGeneratorAlternativePoint$ | async | ready as feature"
            [label]="
              '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.ALTERNATIVE_POINT.TITLE' | translate
            "
            value="{{ feature | value2: featurePropertyKey.value }} {{
              feature | unit: featurePropertyKey.value
            }}"
            [attr.feature]="feature.feature"
          >
          </app-feature-list-item>
        </div>
        <div class="feature-grid-container" viFeatureGrid>
          <!-- heating.secondaryHeatGenerator.configuration.runtime/delay -->
          <app-feature-list-item
            data-at-secondary-heat-generator-configuration-runtime-delay
            *ngIf="secondaryHeatGeneratorConfigurationRuntime$ | async | ready as feature"
            [label]="'+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.START_DELAY.TITLE' | translate"
            [value]="feature?.properties?.delay?.value | minutesOrHours"
            [attr.feature]="feature.feature"
          >
          </app-feature-list-item>

          <!-- heating.secondaryHeatGenerator.configuration.runtime/break -->
          <app-feature-list-item
            data-at-secondary-heat-generator-configuration-runtime-break
            *ngIf="secondaryHeatGeneratorConfigurationRuntime$ | async | ready as feature"
            [label]="
              '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.SHUT_DOWN_DELAY.TITLE' | translate
            "
            [value]="feature?.properties?.break?.value | minutesOrHours"
            [attr.feature]="feature.feature"
          >
          </app-feature-list-item>

          <!-- heating.secondaryHeatGenerator.configuration.runtime/minimal -->
          <app-feature-list-item
            data-at-secondary-heat-generator-configuration-runtime-minimal
            *ngIf="secondaryHeatGeneratorConfigurationRuntime$ | async | ready as feature"
            [label]="
              '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.MINIMAL_RUNTIME.TITLE' | translate
            "
            [value]="feature?.properties?.minimal?.value | minutesOrHours"
            [attr.feature]="feature.feature"
          >
          </app-feature-list-item>
        </div>
        <div class="feature-grid-container" viFeatureGrid viBorderBottom>
          <!-- heating.secondaryHeatGenerator.configuration.timeIntegralThreshold -->
          <app-feature-list-item
            data-at-secondary-heat-generator-configuration-time-integral-threshold
            *ngIf="
              secondaryHeatGeneratorConfigurationTimeIntegralThreshold$ | async | ready as feature
            "
            [label]="
              '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.INTEGRAL_THRESHOLD.TITLE' | translate
            "
            value="{{ feature | value2: featurePropertyKey.value }} {{
              feature | unit: featurePropertyKey.value
            }}"
            [attr.feature]="feature.feature"
          >
          </app-feature-list-item>

          <!-- heating.secondaryHeatGenerator.temperature.offset -->
          <app-feature-list-item
            data-at-secondary-heat-generator-temperature-offset
            *ngIf="secondaryHeatGeneratorTemperatureOffset$ | async | ready as feature"
            [label]="
              '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.TEMPERATURE_OFFSET.TITLE' | translate
            "
            value="{{ feature | value2: featurePropertyKey.value }} {{
              feature | unit: featurePropertyKey.value
            }}"
            [attr.feature]="feature.feature"
          >
          </app-feature-list-item>

          <!-- heating.secondaryHeatGenerator.dhw.offset -->
          <app-feature-list-item
            data-at-secondary-heat-generator-dhw-offset
            *ngIf="secondaryHeatGeneratorDhwOffset$ | async | ready as feature"
            [label]="'+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.OFFSET_DHW.TITLE' | translate"
            value="{{ feature | value2: featurePropertyKey.value }} {{
              feature | unit: featurePropertyKey.value
            }}"
            [attr.feature]="feature.feature"
          >
          </app-feature-list-item>
        </div>
      </ng-template>
    </app-feature-list-container>
  </ng-container>
</div>
